import { setRange } from './helpers';

export const setFloor = setRange('floor');
